import { render, staticRenderFns } from "./CartaoJustificativa.vue?vue&type=template&id=16bea4a4&scoped=true"
import script from "./CartaoJustificativa.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoJustificativa.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoJustificativa.vue?vue&type=style&index=0&id=16bea4a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bea4a4",
  null
  
)

export default component.exports